<!--
   Created by qing on 2020/2/19 2:38 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <ContactBox
    v-else
    :disabled="disabled"
    :key="field.dataId"
    :fieldId="field.dataId"
    :field="field"
    :user-id="$store.state.userId"
    :company-id="$store.getters.currentCompanyId"
    :hasMember="false"
    :hasDep="true"
    :hasRole="false"
    :has-ext="false"
    :has-label="false"
    :has-current="false"
    :multiple="true"
    :selectedDep="current"
    @selectedComplete="selectedComplete"
    @change="filterChange">
  </ContactBox>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {
      };
    },
    methods: {
      selectedComplete(selected) {
        this.current.splice(0, this.current.length, ...selected.depIds)
      }
    }
  };
</script>

<style lang="less" rel="stylesheet/less" scoped>

</style>
